var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgISide2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75676 7.45948L2.22027 2.92051C1.92861 2.39859 1.78278 2.13764 1.80736 1.92398C1.8288 1.73757 1.9278 1.56883 2.08007 1.45918C2.25459 1.3335 2.55353 1.3335 3.1514 1.3335H4.64129C4.86348 1.3335 4.97458 1.3335 5.07423 1.36559C5.16241 1.39398 5.24371 1.44044 5.31293 1.502C5.39116 1.57158 5.44755 1.6673 5.56033 1.85875L8.00007 6.00016L10.4398 1.85875C10.5526 1.6673 10.609 1.57158 10.6872 1.502C10.7564 1.44044 10.8377 1.39398 10.9259 1.36559C11.0256 1.3335 11.1367 1.3335 11.3589 1.3335H12.8487C13.4466 1.3335 13.7456 1.3335 13.9201 1.45918C14.0723 1.56883 14.1713 1.73757 14.1928 1.92398C14.2174 2.13764 14.0715 2.39859 13.7799 2.92051L11.2434 7.45948M7.00007 9.3335L8.00007 8.66683V12.0002M7.16674 12.0002H8.8334M11.0642 7.26936C12.7565 8.96163 12.7565 11.7054 11.0642 13.3976C9.37193 15.0899 6.62822 15.0899 4.93594 13.3976C3.24367 11.7054 3.24367 8.96164 4.93594 7.26936C6.62821 5.5771 9.37192 5.5771 11.0642 7.26936Z",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISide2);
export default __webpack_public_path__ + "static/media/i_side2.5e293f43aec833680004438478081e89.svg";
export { ForwardRef as ReactComponent };